import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { Banner, BannerCreateEdit, BannersType } from "../../types/slices/bannersType";
import { RootState } from "../store";

const initialState: BannersType = {
  statusBanners: ApiStatus.FETCHED,
  banners: [],
  errorMessage: undefined,
  editBanner: {} as BannerCreateEdit,
  selectedBanner: {} as Banner,
  isEdit: false,
  openModal: false,
};

const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    onFetchBanners(state, { payload }: { payload: Banner[] }) {
      state.statusBanners = ApiStatus.FETCHED;
      state.banners = payload;
      state.errorMessage = undefined;
    },
    changeStatusBanners(state, { payload }: { payload: ApiStatus }) {
      state.statusBanners = payload;
    },
    onSetEditBanner(state, { payload }: { payload: BannerCreateEdit }) {
      state.editBanner = payload;
    },
    onSetSelectedBanner(state, { payload }: { payload: Banner }) {
      state.selectedBanner = payload;
    },
    onSetOpenModal(state, { payload }: { payload: boolean }) {
      state.openModal = payload;
    },
    onChangeIsEdit(state, { payload }: { payload: boolean }) {
      state.isEdit = payload;
    },
  },
});

export const selectBannerState = (state: RootState) => state.bannerSlice;
export default bannerSlice.reducer;

export const {
  onFetchBanners,
  changeStatusBanners,
  onSetEditBanner,
  onSetSelectedBanner,
  onSetOpenModal,
  onChangeIsEdit,
} = bannerSlice.actions;